import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from '../../../../../../../../components/modal-list/modal-list.service';
import { Router } from '@angular/router';
import { I18nModule, TranslationService } from '@spartacus/core';
import { ToasterService } from '../../../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../../../components/toaster/toaster.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'close-confirmation',
  standalone: true,
  imports: [I18nModule],
  templateUrl: './close-confirmation.component.html',
  styleUrl: './close-confirmation.component.scss',
})
export class SharedSelectTableConfirmationComponent implements OnInit, OnDestroy {
  toasterMessage = '';
  subscription = new Subscription();

  constructor(
    private modalService: ModalService,
    private router: Router,
    private toasterService: ToasterService,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.translationService
        .translate('accountSelection.notSelectedInfo')
        .subscribe(translation => (this.toasterMessage = translation)),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  cancel() {
    this.modalService.close();
  }

  confirm() {
    this.modalService.close([
      'shared-selection-table-modal',
      'shared-selection-table-close-confirmation',
      'sold-to-modal',
      'ship-to-modal',
    ]);
    this.router.navigate(['/logout']);

    this.toasterService.init({
      type: TOASTER_TYPE.INFO,
      title: 'You must select an option',
      content: this.toasterMessage,
    });
  }
}
